import {ref, computed} from "vue";
import type {Ref, ComputedRef} from "vue"

import Place from "@wikicasa/common/model/Place";
//@ts-ignore
import {decodeTextWithEntities} from "@utils/StringUtils";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";

type OptionalPlace = Place | null | undefined;

interface UsablePlaceName {
    currentPlaceName: Ref<string>;
    locationLabel: ComputedRef<string>;
    zonesLabel: ComputedRef<string>;
    setCustomPlaceLabel: (label: string) => void;
    updateLocationName: (locality: Nullable<Place>) => void;
    updateZoneName: (zone: Nullable<Place>, selectedZones?: number) => void;
    updateSingleDistrictName: (district: Nullable<Place>) => void;
    updateGenericPlaceName: (place: Nullable<Place>) => void;
    updateCityName: (city: Nullable<Place>) => void;
}

export function usePlaceName(): UsablePlaceName {
    const currentPlaceName = ref("")

    const locationLabel = computed((): string => decodeTextWithEntities(window["_labels"].locality))
    const zonesLabel = computed((): string => decodeTextWithEntities(window["_labels"].zones))

    const setCustomPlaceLabel = (label: string): void => {
        currentPlaceName.value = `${label}`
    }
    const updateLocationName = (locality: OptionalPlace): void => {
        if (!locality || !locality.localityID) return;
        currentPlaceName.value = `${locality.cityName} (${locality.provinceAcronym}) - ${locationLabel.value} ${locality.localityName}`;
    }
    const updateZoneName = (zone: OptionalPlace, selectedZones?: number): void => {
        if (!zone) return;

        //Sebastian R.S: In case there are no selected zones
        if (!selectedZones) return;

        if (selectedZones === 1) {
            updateGenericPlaceName(zone);
            return;
        }

        //Sebastian R.S: If the selected zones are more than 1...
        currentPlaceName.value = `${zone.cityName ?? zone.displayName} - ${selectedZones} ${zonesLabel.value}`;
    }
    const updateSingleDistrictName = (district: Nullable<Place>): void => {
        if (!district)
            return
        currentPlaceName.value = `${district.cityName} (${district.provinceAcronym}) - ${district.districtName}`
    }
    const updateGenericPlaceName = (place: OptionalPlace): void => {
        if (!place) return

        currentPlaceName.value = place.displayName;
    }
    const updateCityName = (city: OptionalPlace): void => {
        if (!city) return;

        currentPlaceName.value = `${city.cityName} (${city.provinceAcronym})`;
    }

    return {
        currentPlaceName, //Refs
        locationLabel, zonesLabel, //Computed
        //Methods
        setCustomPlaceLabel,
        updateLocationName,
        updateZoneName,
        updateSingleDistrictName,
        updateGenericPlaceName,
        updateCityName
    }
}

